var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
var MemberAcountPermisstionComponent = /** @class */ (function () {
    function MemberAcountPermisstionComponent(util, apiService) {
        this.util = util;
        this.apiService = apiService;
        this.obj_tag_all = [];
        this.obj_tag = [];
        this.obj_tag_temp = [];
    }
    MemberAcountPermisstionComponent.prototype.ngOnInit = function () {
        var that = this;
        var table = $('#tData').DataTable();
        $('#tData tbody').on('click', 'tr', function () {
            that.obj_data = that.obj_data_all[table.row(this).index()];
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
            }
            else {
                table.$('tr.selected').removeClass('selected');
                $(this).addClass('selected');
            }
        });
        this.InitDropDownMemberType();
    };
    MemberAcountPermisstionComponent.prototype.InitDropDownMemberType = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {};
                        data["lang"] = this.util.GetLanguage();
                        return [4 /*yield*/, this.apiService.post('util', 'GetMemberType', data)];
                    case 1:
                        res = _a.sent();
                        if (res != null) {
                            if (res.responseData != null) {
                                this.util.InitDropdownAll(res.responseData, 'ddlMemberType');
                                this.util.InitDropdown(res.responseData, 'ddlDlgMemberType');
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MemberAcountPermisstionComponent.prototype.BeforeSearch = function () {
        this.util.ShowWaiting(true);
        this.Search();
    };
    MemberAcountPermisstionComponent.prototype.Search = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, resp, obj, table, i, ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.obj_data = null;
                        data = {};
                        data["group_id"] = $('#ddlMemberType').val();
                        return [4 /*yield*/, this.apiService.post('member', 'GetPermiss', data)];
                    case 1:
                        resp = _a.sent();
                        this.util.ShowWaiting(false);
                        if (resp != null) {
                            if (resp.isSuccess) {
                                obj = resp.responseData;
                                this.obj_data_all = obj;
                                table = $('#tData').DataTable();
                                table.clear().draw();
                                for (i = 0; i < obj.length; i++) {
                                    table.row.add([obj[i].group_id,
                                        obj[i].group_desc,
                                        obj[i].update_date,
                                        obj[i].update_user]).draw();
                                }
                            }
                        }
                        else {
                            this.util.ShowWaiting(false);
                            this.util.ErrorDialog('System Error');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        ex_1 = _a.sent();
                        this.util.ShowWaiting(false);
                        this.util.ErrorDialog(ex_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MemberAcountPermisstionComponent.prototype.AddNew = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, resp2, obj, i, ex_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.Clear();
                        $('#txtDlgMenuId').val('');
                        $('#txtDlgMenu').val('');
                        $('#chkAdd').iCheck('uncheck');
                        $('#chkEdit').iCheck('uncheck');
                        $('#chkView').iCheck('uncheck');
                        $('#chkDelete').iCheck('uncheck');
                        $('#chkPrint').iCheck('uncheck');
                        this.util.ShowWaiting(true);
                        this.obj_data = null;
                        // var data1 = {}
                        // data1["document_code"] = 'tagframework';
                        //var resp: any = await this.apiService.post('util', 'getdocno', data1);
                        // if (resp != null) {
                        // if (resp.isSuccess) {
                        // var obj: any = resp.responseData;
                        // $("#txtID").val(obj[0].doc_no);
                        $("#divMain").hide();
                        $("#divDetail").show();
                        data = {};
                        return [4 /*yield*/, this.apiService.post('master', 'getmenu', data)];
                    case 1:
                        resp2 = _a.sent();
                        if (resp2 != null) {
                            if (resp2.isSuccess) {
                                obj = resp2.responseData;
                                if (obj != null) {
                                    this.obj_tag_all = [];
                                    this.obj_tag = [];
                                    for (i = 0; i < obj.length; i++) {
                                        this.obj_tag_temp.push(obj[i]);
                                        this.obj_tag_all.push(obj[i]);
                                    }
                                    this.InitTagAll(this.obj_tag_all);
                                    this.InitTag(this.obj_tag);
                                }
                            }
                            else {
                                this.util.ErrorDialog(resp2.errorMessage);
                            }
                        }
                        else {
                            this.util.ShowWaiting(false);
                            this.util.ErrorDialog('System Error');
                        }
                        this.util.ShowWaiting(false);
                        return [3 /*break*/, 3];
                    case 2:
                        ex_2 = _a.sent();
                        this.util.ShowWaiting(false);
                        this.util.ErrorDialog(ex_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MemberAcountPermisstionComponent.prototype.InitTagAll = function (obj) {
        var that = this;
        $('#divDataAll').html('');
        var str = '';
        str += ' <table class="table table-bordered table-striped"  >';
        str += ' <thead>';
        str += ' <tr>';
        str += ' <th style="text-align: center;">ID</th>';
        str += ' <th style="text-align: center;">Description</th>';
        str += ' <th ></th>';
        str += ' </tr>';
        str += ' </thead>';
        str += ' <tbody>';
        for (var i = 0; i < obj.length; i++) {
            str += ' <tr>';
            str += ' <td align="center">' + obj[i].app_id + '</td>';
            str += ' <td >' + obj[i].app_desc + '</td>';
            str += ' <td  align="center">';
            str += ' <button type="button" class="btn btn-default" role="removerowall1" name="' + obj[i].app_id + '"><i class="fa fa-angle-right"></i></button>';
            str += ' </td>';
            str += ' </tr>';
        }
        str += ' </tbody>';
        str += ' </table>';
        $('#divDataAll').html(str);
        $("[role=removerowall1]").off('click');
        $("[role=removerowall1]").click(function () {
            that.RemoveRowAll($(this).attr('name'));
        });
    };
    MemberAcountPermisstionComponent.prototype.InitTag = function (obj) {
        var that = this;
        $('#divDataSelect').html('');
        var str = '';
        str += ' <table class="table table-bordered table-striped"  >';
        str += ' <thead>';
        str += ' <tr>';
        str += ' <th style="text-align: center;">ID</th>';
        str += ' <th style="text-align: center;">Description</th>';
        str += ' <th ></th>';
        str += ' </tr>';
        str += ' </thead>';
        str += ' <tbody>';
        for (var i = 0; i < obj.length; i++) {
            str += ' <tr>';
            str += ' <td align="center">' + obj[i].app_id + '</td>';
            str += ' <td >' + obj[i].app_desc + '</td>';
            str += ' <td  align="center">';
            str += ' <button type="button" class="btn btn-default" role="permiss" title="แก้ไขสิทธิ์" name="' + obj[i].app_id + '"><i class="fa fa-edit"></i></button>';
            str += ' <button type="button" class="btn btn-default" role="removerow1" name="' + obj[i].app_id + '"><i class="fa fa-angle-left"></i></button>';
            str += ' </td>';
            str += ' </tr>';
        }
        str += ' </tbody>';
        str += ' </table>';
        $('#divDataSelect').html(str);
        $("[role=removerow1]").off('click');
        $("[role=removerow1]").click(function () {
            that.RemoveRow($(this).attr('name'));
        });
        $("[role=permiss]").off('click');
        $("[role=permiss]").click(function () {
            that.InitPermiss($(this).attr('name'));
        });
    };
    MemberAcountPermisstionComponent.prototype.Cancel = function () {
        $("#divDetail").hide();
        $("#divMain").show();
    };
    MemberAcountPermisstionComponent.prototype.Clear = function () {
        $('#ddlDlgMemberType').prop('disabled', false);
    };
    MemberAcountPermisstionComponent.prototype.RemoveRowAll = function (x) {
        for (var i = 0; i < this.obj_tag_all.length; i++) {
            if (this.obj_tag_all[i].app_id == x) {
                this.obj_tag.push(this.obj_tag_all[i]);
                this.obj_tag_all.splice(i, 1);
                break;
            }
        }
        this.obj_tag = this.obj_tag.sort(function (a, b) {
            if (a.app_order > b.app_order) {
                return 1;
            }
            if (a.app_order < b.app_order) {
                return -1;
            }
            return 0;
        });
        this.InitTagAll(this.obj_tag_all);
        this.InitTag(this.obj_tag);
    };
    MemberAcountPermisstionComponent.prototype.RemoveRow = function (x) {
        for (var i = 0; i < this.obj_tag.length; i++) {
            if (this.obj_tag[i].app_id == x) {
                this.obj_tag_all.push(this.obj_tag[i]);
                this.obj_tag.splice(i, 1);
                break;
            }
        }
        this.obj_tag_all = this.obj_tag_all.sort(function (a, b) {
            if (a.app_order > b.app_order) {
                return 1;
            }
            if (a.app_order < b.app_order) {
                return -1;
            }
            return 0;
        });
        this.InitTagAll(this.obj_tag_all);
        this.InitTag(this.obj_tag);
    };
    MemberAcountPermisstionComponent.prototype.AddAllTag = function () {
        this.obj_tag_all = [];
        this.obj_tag = [];
        for (var i = 0; i < this.obj_tag_temp.length; i++) {
            this.obj_tag.push(this.obj_tag_temp[i]);
        }
        this.InitTagAll(this.obj_tag_all);
        this.InitTag(this.obj_tag);
    };
    MemberAcountPermisstionComponent.prototype.RemoveAllTag = function () {
        this.obj_tag = [];
        this.obj_tag_all = [];
        for (var i = 0; i < this.obj_tag_temp.length; i++) {
            this.obj_tag_all.push(this.obj_tag_temp[i]);
        }
        this.InitTagAll(this.obj_tag_all);
        this.InitTag(this.obj_tag);
    };
    MemberAcountPermisstionComponent.prototype.Save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, resp, ex_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        if (!this.util.ValidateForm()) return [3 /*break*/, 5];
                        if (!(this.obj_tag != null)) return [3 /*break*/, 4];
                        if (!(this.obj_tag.length > 0)) return [3 /*break*/, 2];
                        data = {};
                        data["group_id"] = $('#ddlDlgMemberType').val();
                        //data["framework_desc"] = desc_th;
                        //data["framework_desc_en"] = desc_en;
                        data["list_menu"] = this.obj_tag;
                        return [4 /*yield*/, this.apiService.post('member', 'insertupdatepermiss', data)];
                    case 1:
                        resp = _a.sent();
                        this.util.ShowWaiting(false);
                        if (resp != null) {
                            if (resp.isSuccess) {
                                this.util.SuccessDialog('บันทึกสำเร็จ');
                                this.obj_tag_all = [];
                                this.obj_tag = [];
                                this.obj_tag_temp = [];
                                this.obj_data_all = null;
                                this.obj_data = null;
                                $("#divMain").show();
                                $("#divDetail").hide();
                                this.Search();
                            }
                            else {
                                this.util.ErrorDialog(resp.errorMessage);
                            }
                        }
                        else {
                            this.util.ShowWaiting(false);
                            this.util.ErrorDialog('System Error');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.util.ErrorDialog('กรุณาเลือกรายการ');
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        this.util.ErrorDialog('กรุณาเลือกรายการ');
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        ex_3 = _a.sent();
                        this.util.ErrorDialog(ex_3);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    MemberAcountPermisstionComponent.prototype.EditData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, resp, obj, i, data1, resp, obj, i, data2, resp, obj, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.obj_data != null)) return [3 /*break*/, 4];
                        $('#txtDlgMenuId').val('');
                        $('#txtDlgMenu').val('');
                        $('#chkAdd').iCheck('uncheck');
                        $('#chkEdit').iCheck('uncheck');
                        $('#chkView').iCheck('uncheck');
                        $('#chkDelete').iCheck('uncheck');
                        $('#chkPrint').iCheck('uncheck');
                        this.util.ShowWaiting(true);
                        $("#ddlDlgMemberType").prop('disabled', true);
                        $("#ddlDlgMemberType").val(this.obj_data.group_id);
                        $("#divDetail").show();
                        $("#divMain").hide();
                        data = {};
                        data["group_id"] = '';
                        return [4 /*yield*/, this.apiService.post('master', 'getmenu', data)];
                    case 1:
                        resp = _a.sent();
                        if (resp != null) {
                            if (resp.isSuccess) {
                                obj = resp.responseData;
                                if (obj != null) {
                                    for (i = 0; i < obj.length; i++) {
                                        this.obj_tag_temp.push(obj[i]);
                                    }
                                }
                            }
                            else {
                                this.util.ErrorDialog(resp.errorMessage);
                            }
                        }
                        else {
                            this.util.ShowWaiting(false);
                            this.util.ErrorDialog('System Error');
                        }
                        data1 = {};
                        data1["group_id"] = this.obj_data.group_id;
                        return [4 /*yield*/, this.apiService.post('master', 'GetMenuPermissNotIN', data1)];
                    case 2:
                        resp = _a.sent();
                        if (resp != null) {
                            if (resp.isSuccess) {
                                obj = resp.responseData;
                                if (obj != null) {
                                    this.obj_tag_all = [];
                                    for (i = 0; i < obj.length; i++) {
                                        this.obj_tag_all.push(obj[i]);
                                    }
                                    this.InitTagAll(this.obj_tag_all);
                                }
                            }
                            else {
                                this.util.ErrorDialog(resp.errorMessage);
                            }
                        }
                        else {
                            this.util.ShowWaiting(false);
                            this.util.ErrorDialog('System Error');
                        }
                        data2 = {};
                        data2["group_id"] = this.obj_data.group_id;
                        return [4 /*yield*/, this.apiService.post('master', 'GetMenuPermissIN', data2)];
                    case 3:
                        resp = _a.sent();
                        if (resp != null) {
                            if (resp.isSuccess) {
                                obj = resp.responseData;
                                if (obj != null) {
                                    this.obj_tag = [];
                                    for (i = 0; i < obj.length; i++) {
                                        this.obj_tag.push(obj[i]);
                                    }
                                    this.InitTag(this.obj_tag);
                                }
                            }
                            else {
                                this.util.ErrorDialog(resp.errorMessage);
                            }
                        }
                        else {
                            this.util.ShowWaiting(false);
                            this.util.ErrorDialog('System Error');
                        }
                        this.util.ShowWaiting(false);
                        return [3 /*break*/, 5];
                    case 4:
                        this.util.ErrorDialog('กรุณาเลือกรายการที่ต้องการแก้ไข');
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MemberAcountPermisstionComponent.prototype.UpdatePermiss = function () {
        var app_id = $('#txtDlgMenuId').val();
        if (this.obj_tag != null) {
            if (this.obj_tag.length > 0) {
                for (var i = 0; i < this.obj_tag.length; i++) {
                    if (app_id == this.obj_tag[i].app_id) {
                        if ($('#chkAdd').prop("checked")) {
                            this.obj_tag[i].add_status = "1";
                        }
                        else {
                            this.obj_tag[i].add_status = "0";
                        }
                        if ($('#chkEdit').prop("checked")) {
                            this.obj_tag[i].edit_status = "1";
                        }
                        else {
                            this.obj_tag[i].edit_status = "0";
                        }
                        if ($('#chkView').prop("checked")) {
                            this.obj_tag[i].view_status = "1";
                        }
                        else {
                            this.obj_tag[i].view_status = "0";
                        }
                        if ($('#chkDelete').prop("checked")) {
                            this.obj_tag[i].delete_status = "1";
                        }
                        else {
                            this.obj_tag[i].delete_status = "0";
                        }
                        if ($('#chkPrint').prop("checked")) {
                            this.obj_tag[i].print_status = "1";
                        }
                        else {
                            this.obj_tag[i].print_status = "0";
                        }
                        console.log('yes');
                        this.util.SuccessDialog('ปรับปรุงสำเร็จ');
                        break;
                    }
                }
            }
        }
    };
    MemberAcountPermisstionComponent.prototype.InitPermiss = function (app_id) {
        if (this.obj_tag != null) {
            if (this.obj_tag.length > 0) {
                for (var i = 0; i < this.obj_tag.length; i++) {
                    if (app_id == this.obj_tag[i].app_id) {
                        $('#txtDlgMenuId').val(this.obj_tag[i].app_id);
                        $('#txtDlgMenu').val(this.obj_tag[i].app_desc);
                        if (this.obj_tag[i].add_status == "1") {
                            $('#chkAdd').iCheck('check');
                        }
                        else {
                            $('#chkAdd').iCheck('uncheck');
                        }
                        if (this.obj_tag[i].edit_status == "1") {
                            $('#chkEdit').iCheck('check');
                        }
                        else {
                            $('#chkEdit').iCheck('uncheck');
                        }
                        if (this.obj_tag[i].view_status == "1") {
                            $('#chkView').iCheck('check');
                        }
                        else {
                            $('#chkView').iCheck('uncheck');
                        }
                        if (this.obj_tag[i].delete_status == "1") {
                            $('#chkDelete').iCheck('check');
                        }
                        else {
                            $('#chkDelete').iCheck('uncheck');
                        }
                        if (this.obj_tag[i].print_status == "1") {
                            $('#chkPrint').iCheck('check');
                        }
                        else {
                            $('#chkPrint').iCheck('uncheck');
                        }
                        break;
                    }
                }
            }
        }
    };
    return MemberAcountPermisstionComponent;
}());
export { MemberAcountPermisstionComponent };



// WEBPACK FOOTER //
// ./src/app/member/member-acount-permisstion/member-acount-permisstion.component.ts.pre-build-optimizer.js